// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_int32 = require("rescript/lib/js/caml_int32.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Webapi__Dom__Document = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Document.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var User$ReactHooksTemplate = require("./user.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var InviteUser$ReactHooksTemplate = require("./InviteUser.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");
var OverlayClosable$ReactHooksTemplate = require("../common/OverlayClosable.res.js");
var ConfirmationDialog$ReactHooksTemplate = require("./ConfirmationDialog.res.js");
var UserInvitationItem$ReactHooksTemplate = require("./UserInvitationItem.res.js");
var UserInvitationHeader$ReactHooksTemplate = require("./UserInvitationHeader.res.js");

function deleteUser(user) {
  var userId = String(User$ReactHooksTemplate.id(user));
  return Http$ReactHooksTemplate.fetchPostJSON("/api/v1/users/" + userId + "/delete", {});
}

function reducer(state, action) {
  if (typeof action !== "object") {
    switch (action) {
      case "LoadUsers" :
          return {
                  users: state.users,
                  userToDelete: state.userToDelete,
                  statusCount: state.statusCount,
                  loadingUsers: true,
                  loadingStatusCount: state.loadingStatusCount
                };
      case "LoadStatusCount" :
          return {
                  users: state.users,
                  userToDelete: state.userToDelete,
                  statusCount: state.statusCount,
                  loadingUsers: state.loadingUsers,
                  loadingStatusCount: true
                };
      case "CancelDelete" :
          return {
                  users: state.users,
                  userToDelete: undefined,
                  statusCount: state.statusCount,
                  loadingUsers: state.loadingUsers,
                  loadingStatusCount: state.loadingStatusCount
                };
      
    }
  } else {
    switch (action.TAG) {
      case "DisplayList" :
          return {
                  users: action._0,
                  userToDelete: state.userToDelete,
                  statusCount: state.statusCount,
                  loadingUsers: false,
                  loadingStatusCount: state.loadingStatusCount
                };
      case "DisplayStatusCount" :
          return {
                  users: state.users,
                  userToDelete: state.userToDelete,
                  statusCount: action._0,
                  loadingUsers: state.loadingUsers,
                  loadingStatusCount: false
                };
      case "DisplayDeleteConfirmation" :
          return {
                  users: state.users,
                  userToDelete: action._0,
                  statusCount: state.statusCount,
                  loadingUsers: state.loadingUsers,
                  loadingStatusCount: state.loadingStatusCount
                };
      
    }
  }
}

function totalPages(total_records, perPage) {
  return Caml_int32.div(total_records - 1 | 0, perPage) + 1 | 0;
}

function totalRecord(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

function perPage(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

var initialState = {
  users: /* [] */0,
  userToDelete: undefined,
  statusCount: {
    active: 0,
    inActive: 0
  },
  loadingUsers: true,
  loadingStatusCount: true
};

var searchPlaceholder = "Search Users";

function UserInvitation(props) {
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        
      });
  var setSearchKey = match$1[1];
  var queryParams = Querystringify.parse(props.search);
  var x = Js_dict.get(queryParams, "page");
  var currentPage;
  if (x !== undefined && x !== "") {
    var page = Belt_Int.fromString(x);
    currentPage = page !== undefined ? page : 1;
  } else {
    currentPage = 1;
  }
  var x$1 = Js_dict.get(queryParams, "search");
  var currentSearchKey = x$1 !== undefined && x$1 !== "" ? x$1 : undefined;
  var match$2 = React.useState(function (param) {
        return {
                total: "1",
                perPage: "1",
                currentPage: currentPage
              };
      });
  var setPageInfo = match$2[1];
  var pageInfo = match$2[0];
  var fetchUsers = function (param) {
    var pageNumber = String(pageInfo.currentPage);
    var url = currentSearchKey !== undefined ? "/api/v1/users?page=" + pageNumber + "&search=" + currentSearchKey : "/api/v1/users?page=" + pageNumber;
    return Js_promise.then_((function (param) {
                  var headers = param[0];
                  var x = headers.get("Total");
                  var total = x !== null ? (
                      x === null ? undefined : Caml_option.some(x)
                    ) : "1";
                  var x$1 = headers.get("Per-Page");
                  var perPage = x$1 !== null ? (
                      x$1 === null ? undefined : Caml_option.some(x$1)
                    ) : "1";
                  var users = Js_promise.then_((function (json) {
                          return Promise.resolve(Json_decode.field("users", (function (param) {
                                            return Json_decode.list(User$ReactHooksTemplate.decode, param);
                                          }), json));
                        }), param[1]);
                  Curry._1(setSearchKey, (function (param) {
                          return currentSearchKey;
                        }));
                  return Promise.resolve([
                              users,
                              [
                                total,
                                perPage
                              ]
                            ]);
                }), Http$ReactHooksTemplate.fetchGetJSONWithHeader(url));
  };
  var match$3 = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  React.useEffect((function (param) {
          Curry._1(dispatch, "LoadStatusCount");
          var url = currentSearchKey !== undefined ? "/api/v1/users/status_wise_count?search=" + currentSearchKey : "/api/v1/users/status_wise_count";
          Js_promise.then_((function (json) {
                  var statusCount_active = Belt_Option.getWithDefault(Json_decode.field("count", (function (param) {
                              return Json_decode.optional((function (param) {
                                            return Json_decode.field("true", Json_decode.$$int, param);
                                          }), param);
                            }), json), 0);
                  var statusCount_inActive = Belt_Option.getWithDefault(Json_decode.field("count", (function (param) {
                              return Json_decode.optional((function (param) {
                                            return Json_decode.field("false", Json_decode.$$int, param);
                                          }), param);
                            }), json), 0);
                  var statusCount = {
                    active: statusCount_active,
                    inActive: statusCount_inActive
                  };
                  Curry._1(setSearchKey, (function (param) {
                          return currentSearchKey;
                        }));
                  Curry._1(dispatch, {
                        TAG: "DisplayStatusCount",
                        _0: statusCount
                      });
                  return Promise.resolve();
                }), Http$ReactHooksTemplate.fetchGetJSON(url));
        }), [currentSearchKey]);
  React.useEffect((function (param) {
          Curry._1(dispatch, "LoadUsers");
          Js_promise.then_((function (param) {
                  var paginationInfo = param[1];
                  var perPage = paginationInfo[1];
                  var total = paginationInfo[0];
                  Curry._1(setPageInfo, (function (state) {
                          return {
                                  total: total,
                                  perPage: perPage,
                                  currentPage: state.currentPage
                                };
                        }));
                  return Js_promise.then_((function (xs) {
                                return Promise.resolve(Curry._1(dispatch, {
                                                TAG: "DisplayList",
                                                _0: xs
                                              }));
                              }), param[0]);
                }), fetchUsers());
        }), [
        currentPage,
        currentSearchKey
      ]);
  var handleCancelDelete = function (param) {
    Curry._1(dispatch, "CancelDelete");
  };
  var bodyElement = Belt_Option.getExn(Webapi__Dom__Document.asHtmlDocument(document)).body;
  var $$class = Belt_Option.getExn((bodyElement == null) ? undefined : Caml_option.some(bodyElement)).classList;
  $$class.add("bg-ghostwhiteblue");
  var tmp;
  if (Curry._1(match$3[0], "AddUser")) {
    var match$4 = state.userToDelete;
    tmp = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("h2", {
                        children: "Survey workspace sharing",
                        className: "text-base font-semibold py-3"
                      }),
                  match$4 !== undefined ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx(InviteUser$ReactHooksTemplate.make, {})
                ],
                className: "justify-between items-center mb-30-px "
              }),
          className: "flex flex-col"
        });
  } else {
    tmp = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("h2", {
                children: "Users",
                className: "mb-30-px text-2xl"
              }),
          className: "flex justify-between items-center mb-30-px "
        });
  }
  var tmp$1;
  if (state.loadingUsers) {
    tmp$1 = JsxRuntime.jsx(JsxRuntime.Fragment, {
          children: Caml_option.some(JsxRuntime.jsx("p", {
                    children: "Fetching users..."
                  }))
        });
  } else {
    var user = state.userToDelete;
    var tmp$2;
    if (user !== undefined) {
      var partial_arg = state.users;
      tmp$2 = JsxRuntime.jsx(OverlayClosable$ReactHooksTemplate.make, {
            hidden: false,
            children: JsxRuntime.jsx(ConfirmationDialog$ReactHooksTemplate.make, {
                  user: user,
                  handleCancel: handleCancelDelete,
                  handleDelete: (function (param) {
                      Js_promise.then_((function (param) {
                              return Promise.resolve((window.location.reload(), undefined));
                            }), Js_promise.then_((function (param) {
                                  return Promise.resolve(Curry._1(dispatch, {
                                                  TAG: "DisplayList",
                                                  _0: partial_arg
                                                }));
                                }), deleteUser(user)));
                    }),
                  handleClose: handleCancelDelete
                })
          });
    } else {
      tmp$2 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("p", {
                                  children: "All",
                                  className: "text-darkcharcoal"
                                }),
                            JsxRuntime.jsx("p", {
                                  children: String(List.length(state.users)),
                                  className: "bg-periwinkle w-6 h-4 rounded-lg text-xs\n                                  flex items-center justify-center text-luckyPoint"
                                })
                          ],
                          className: "flex flex-wrap border-b-2 gap-2 items-center justify-center\n                              border-dodgerBlue font-medium text-sm h-40-px"
                        }),
                    className: "flex text-aurometalsaurus h-40-px\n                              border-b border-gray-300 mb-20-px"
                  }),
              JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("input", {
                                    className: "border border-gray-300 rounded-lg\n                                bg-white h-8 px-3 placeholder-gray-400\n                                focus:outline-none w-full",
                                    placeholder: searchPlaceholder,
                                    type: "text",
                                    value: Belt_Option.getWithDefault(match$1[0], "")
                                  }),
                              JsxRuntime.jsx("button", {
                                    children: JsxRuntime.jsx("img", {
                                          className: "h-3.5 w-3.5",
                                          src: Image$ReactHooksTemplate.newSearchGrey
                                        }),
                                    className: "w-8 h-8 flex items-center justify-center\n                                border border-gray-300 rounded-lg focus:outline-none",
                                    type: "button"
                                  }),
                              JsxRuntime.jsx("button", {
                                    children: JsxRuntime.jsx("img", {
                                          className: "h-3.5 w-3.5",
                                          src: Image$ReactHooksTemplate.refreshIcon
                                        }),
                                    className: "w-8 h-8 flex items-center justify-center\n                                border border-gray-300 rounded-lg focus:outline-none",
                                    type: "button"
                                  }),
                              JsxRuntime.jsx("button", {
                                    children: JsxRuntime.jsx("img", {
                                          className: "h-3.5 w-3.5",
                                          src: Image$ReactHooksTemplate.greyFilter
                                        }),
                                    className: "w-8 h-8 flex items-center justify-center border\n                                border-gray-300 rounded-lg focus:outline-none",
                                    type: "button"
                                  })
                            ],
                            className: "flex gap-2 w-full pr-2"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("img", {
                                    className: "float-right px-2 py-3",
                                    src: Image$ReactHooksTemplate.chevronDown
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx("p", {
                                          children: "Bulk Actions",
                                          className: "text-center text-sm text-gray-500"
                                        }),
                                    className: "flex flex-wrap pl-2 py-2"
                                  })
                            ],
                            className: "relative bg-aquahaze text-gray-700 rounded-lg\n                              h-8 w-1/5"
                          })
                    ],
                    className: "flex items-center justify-between mb-2 w-full"
                  }),
              JsxRuntime.jsx(UserInvitationHeader$ReactHooksTemplate.make, {}),
              JsxRuntime.jsx("div", {
                    children: $$Array.of_list(List.map((function (user) {
                                return JsxRuntime.jsx(UserInvitationItem$ReactHooksTemplate.make, {
                                            email: User$ReactHooksTemplate.email(user),
                                            active: user.active,
                                            roles: user.roles,
                                            handleDelete: (function (param) {
                                                return Curry._1(dispatch, {
                                                            TAG: "DisplayDeleteConfirmation",
                                                            _0: user
                                                          });
                                              }),
                                            handleEdit: (function (param) {
                                                return RescriptReactRouter.push("/users/edit/" + String(User$ReactHooksTemplate.id(user)));
                                              })
                                          }, String(User$ReactHooksTemplate.id(user)));
                              }), state.users)),
                    className: "shadow bg-white"
                  })
            ]
          });
    }
    tmp$1 = JsxRuntime.jsx(JsxRuntime.Fragment, {
          children: Caml_option.some(tmp$2)
        });
  }
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsxs("div", {
                              children: [
                                tmp,
                                tmp$1
                              ],
                              className: "m-16 w-3/5 bg-white px-3 rounded-lg"
                            }),
                        className: "pb-8"
                      }))
            });
}

var emptyPageInfo = {
  total: "1",
  perPage: "1",
  currentPage: 1
};

var make = UserInvitation;

exports.deleteUser = deleteUser;
exports.reducer = reducer;
exports.totalPages = totalPages;
exports.emptyPageInfo = emptyPageInfo;
exports.totalRecord = totalRecord;
exports.perPage = perPage;
exports.initialState = initialState;
exports.searchPlaceholder = searchPlaceholder;
exports.make = make;
/* react Not a pure module */
